export default __webpack_public_path__ + "static/media/feature-backup-3.37666dc0.png";